import React, { useEffect, useState } from 'react';
import { ButtonComp } from 'atoms/Buttons/index';
import { useSelector, useDispatch } from 'react-redux';
import { modifyData, getFinalContentData, getPageCount, getPageData } from '../utils/dealsAndOffersUtils';
import {
  getApplicableCouponsAction,
  getNonLocalisedCouponsAction,
  getLoggedinNonLocalizedCoupon,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import OfferDealsCard from './OfferDealsCard';
import { DEFAULT_PAGE_SIZE, DEFAULT_START_PAGE, VIEWED, OF, LOAD_MORE } from '../constants/offersAndDealsConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { goToMenuPage, filterOutBlackListedCoupons } from 'common/utilities/utils';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';

const DealsAndOffersCard = props => {
  const { isLocalized = false, onStartOrderClick, isLoggedIn = false, copyCoupon } = props;
  const tenantData = useSelector(data => data.tenantReducer);
  const [currPage, setPage] = useState(DEFAULT_START_PAGE);
  const { tenantId = '', componentOptions } = tenantData;
  const { showViewDetailsButton } = componentOptions?.routes?.Home?.offersAndDeals || {};
  const cartReducer = useSelector(data => data.cartReducer);
  const profileReducer = useSelector(data => data.profileReducer);
  const { applicableCoupons = [], cartData = {} } = cartReducer;
  const { customer: { id: cartCustomerId } = {} } = cartData;
  const { customerId } = AuthManager.getInstance();
  const dispatch = useDispatch();

  /**
   * Modifying API response into mappable data
   */
  const contentData = getFinalContentData(
    isLocalized,
    isLoggedIn,
    modifyData(filterOutBlackListedCoupons(applicableCoupons)),
  );
  const paginatedData = getPageData(currPage, DEFAULT_PAGE_SIZE, contentData);

  const pageCount = getPageCount(DEFAULT_PAGE_SIZE, contentData);

  const couponApplyHandler = discountCode => {
    if (isLocalized) {
      copyCoupon(discountCode);
      goToMenuPage(props.history);
    } else {
      copyCoupon(discountCode);
      onStartOrderClick();
    }
  };

  /**
   * useEffect to dispatch action to get the applicable coupons
   */
  useEffect(() => {
    if (cartData?.id || isLoggedIn || isLocalized) {
      tenantId && getCoupons();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, isLocalized, isLoggedIn, profileReducer, tenantId]);

  const getCoupons = () => {
    if (isLocalized) {
      customerId === cartCustomerId &&
        dispatch(
          getApplicableCouponsAction({
            basketId: cartData?.id,
            tenantId,
          }),
        );
    } else if (isLoggedIn) {
      profileReducer.customerId &&
        dispatch(
          getLoggedinNonLocalizedCoupon({
            tenantId,
            //userId: 'd8d5f5be-f93b-468a-84e4-76161498cef3'
            userId: profileReducer.customerId,
          }),
        );
    } else {
      dispatch(
        getNonLocalisedCouponsAction({
          tenantId,
        }),
      );
    }
  };

  /**
   * Method to return Card for Offers And Deals
   * @returns JSX.Element
   */
  const renderOffersAndDealsCard = () =>
    paginatedData.map((data, indx) => {
      return (
        <OfferDealsCard
          key={indx}
          couponApplyHandler={couponApplyHandler}
          onStartOrderClick={onStartOrderClick}
          data={data}
          id={indx}
          tenantId={tenantId}
          showViewDetailsButton={showViewDetailsButton}
          tenantData={tenantData}
        />
      );
    });

  return (
    <div className='offer-deals-container'>
      <div className='offer-card-container'>{renderOffersAndDealsCard()}</div>
      {currPage !== pageCount && pageCount > 1 && (
        <div className='load-more-container'>
          <ButtonComp
            data-testid='load-more-btn'
            className='button whiteButton blackBorder load-btn'
            onClick={() => setPage(currPage + 1)}
            disabled={currPage === pageCount}
          >
            {translateWithI18Next(LOAD_MORE)}
          </ButtonComp>
          <span className='page-desc'>
            {`${translateWithI18Next(VIEWED)} ${DEFAULT_PAGE_SIZE * currPage} ${translateWithI18Next(OF)} ${
              contentData.length
            }`}
          </span>
        </div>
      )}
    </div>
  );
};

export default DealsAndOffersCard;
